import React from 'react';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';

const NoticeFileList = ({
    apiRef,
    columns,
    files,
    error,
    loading,
    columnVisibilityModel
}) => {
  return (
    <div style={{ display: 'flex', height: '350px' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          apiRef={apiRef}
          rows={files ? files : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '공지사항_첨부파일_리스트' },
          }}
          loading={loading}
          editMode="row"
          initialState={{ pinnedColumns: { right: ['actions'] } }}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          pagination
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
        />
      </div>
    </div>
  )
}

export default NoticeFileList